export var sizes = {
  xxSmall: 4,
  xSmall: 8,
  small: 12,
  medium: 16,
  large: 24,
  xLarge: 32,
  xxLarge: 48
};
export var modalSizes = {
  small: 320,
  medium: 480,
  large: 640,
  xLarge: 720
};
//# sourceMappingURL=spacing.js.map